import { SigninForm } from '@/components/auth/signin-form';
import { KaajaLogo } from '@/components/common/kaaja-logo';
import { Box, Stack } from 'TBM/OldSharedUI';
import Link from 'next/link';
import { useRouter } from 'next/router';

export default function Page() {
  const router = useRouter();

  return (
    <Stack
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bg="neutral50"
    >
      {router.query.fromPasswordReset === '1' && (
        <Box
          padding={5}
          width="100%"
          maxWidth="24rem"
          bg="pinkAccent300"
          color="white"
          borderRadius="4px"
          marginBottom={5}
        >
          {router.locale?.startsWith('it')
            ? 'Password cambiata correttamente!'
            : 'Password changed correctly!'}
        </Box>
      )}
      <Box maxWidth="24rem" width="100%" bg="white" p={6} borderRadius="4px">
        <Link href="/" passHref>
          <Box as="a" textAlign="center">
            <KaajaLogo />
          </Box>
        </Link>
        <SigninForm />
      </Box>
    </Stack>
  );
}
